import React, { useEffect } from 'react';
import { CommonHeader, Loader, ErrorSuccessModal } from '../../../components/commons';
import BusinessAddressForm from '../../../components/ClientSettings/AddressManager/BusinessAddressForm';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import {
  addBusinessAddressAction,
  editBusinessAddressAction,
  resetClientSettingsError,
  resetClientSettingsSuccess
} from '../../../redux/clientSettings';
import { AddBusinessAddressPayloadType, EditBusinessAddressPayloadType } from '../../../commonTypes/clientSettingsTypes';
import { resetSession } from '../../../redux/auth';
import { useMenuCheck } from '../../../customHooks/useMenuCheck';
import { GetPathBeforeClientCode } from '../../../components/commons/UserManagement';

type AppProps = {
  token: string | null;
  history?: any;
  success: number | null;
  fetching: boolean;
  statusCode: number | null;
  error: string | null;
  dispatchResetClientSettingsError: () => void;
  dispatchResetClientSettingsSuccessAction: () => void;
  dispatchAddBussinessAddressAction: (data: AddBusinessAddressPayloadType) => void;
  dispatchEditBusinessAddressAction: (data: EditBusinessAddressPayloadType) => void;
  dispatchResetSession: () => void;
}

const AddBusinessAddress = ({
  token,
  history,
  success,
  fetching,
  statusCode,
  error,
  dispatchAddBussinessAddressAction,
  dispatchEditBusinessAddressAction,
  dispatchResetClientSettingsError,
  dispatchResetClientSettingsSuccessAction,
  dispatchResetSession
}: AppProps) => {
  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code;
  const url:string=history?.location?.pathname

  //============================userManagement===============
  const [isAddressAddUrlPresent,setIsAddressAddUrlPresent]=useMenuCheck()
  //=============================================================

  useEffect(() => {
    setIsAddressAddUrlPresent(GetPathBeforeClientCode(url),"url")
    dispatchResetClientSettingsError();
    dispatchResetClientSettingsSuccessAction();
     //eslint-disable-next-line
  }, []);

  useEffect(()=>{
    if(isAddressAddUrlPresent===false){
      history.push("/access-denied")
    }
     //eslint-disable-next-line
  },[isAddressAddUrlPresent])


  const handleAddBusinessAddress = (data: any) => {
    if (token) {
      let finalData = {
        token,
        client_code,
        ...data
      }
      dispatchAddBussinessAddressAction(finalData);
    }
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        )
      } else if ((!!error && statusCode !== 401)) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientSettingsError();
            }}
          />
        )
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Business Address Added Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetClientSettingsSuccessAction();
            history.goBack();
          }}
          statusCode={statusCode}
        />
      )
    }

    return false;
  }

  return (
    <>
      <div className='row'>
        <div className="col-md-6 mb-3">
          <CommonHeader
            title='Add Business Address'
            company_name={company_name}
            client_code={client_code}
          />
        </div>
      </div>
      <BusinessAddressForm
        history={history}
        handleAddBusinessAddress={handleAddBusinessAddress}
      />
      {handleErrorModal()}
      {fetching && <Loader />}
    </>
  )
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.clientSettings.fetching,
  success: state.clientSettings.success,
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetClientSettingsSuccessAction: () => dispatch(resetClientSettingsSuccess()),
  dispatchAddBussinessAddressAction: (data: AddBusinessAddressPayloadType) =>
    dispatch(addBusinessAddressAction(data)),
  dispatchEditBusinessAddressAction: (data: EditBusinessAddressPayloadType) =>
    (editBusinessAddressAction(data)),
  dispatchResetSession: () => dispatch(resetSession())
})

export default connect(mapStateTopProps, mapDispatchToProps)(AddBusinessAddress);